import { render, staticRenderFns } from "./BankruptcyApplications.vue?vue&type=template&id=78cb5b2d&scoped=true&"
import script from "./BankruptcyApplications.vue?vue&type=script&lang=js&"
export * from "./BankruptcyApplications.vue?vue&type=script&lang=js&"
import style0 from "./BankruptcyApplications.vue?vue&type=style&index=0&id=78cb5b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cb5b2d",
  null
  
)

export default component.exports